import { Component, OnInit } from '@angular/core';
import { StateService } from '../../../core/services/state.service';
import { DataTaskService } from '../../../core/services/data-task.service';
import { Item } from '../../../core/components/listbox/listbox.component';

@Component({
  selector: 'tt-labour-salary-types',
  templateUrl: './labour-salary-types.component.html',
  styleUrls: ['./labour-salary-types.component.css']
})
export class LabourSalaryTypesComponent implements OnInit {
    argType;

    argValue;

    public setting?: Setting;

    public itemsListSalaryTypes: Item[] = [];

    constructor(private stateService: StateService, private datatask: DataTaskService) {
        this.argType = this.stateService.getStateParams()['argtype'];
        this.argValue = this.stateService.getStateParams()['argvalue'];
    }

    private async loadSetting() {
        if (!!this.argType && !!this.argValue) {
            this.setting = (await this.datatask.Post(1421, {
                argtype: this.argType,
                argvalue: this.argValue
            }))[0];
        }
    }

    private async loadSalaryTypes(): Promise<void> {
        if (!!this.setting) {
            this.itemsListSalaryTypes = await this.datatask.Post(1422, this.setting);
        }
    }

    private async init() {
        await this.loadSetting();
        this.loadSalaryTypes();
    }

    ngOnInit() {
        this.init();
    }
}

interface Setting {
    argtype: string;
    argvalue: string;
    searchtext: string;
    page_heading: string;
}
